import { FlexBox, JoonUIColor, SPACING } from "@joonapp/web-shared"

export const SelectRowContainer = ({
  children,
  style,
}: {
  children: React.ReactNode
  style?: React.CSSProperties
}) => {
  return (
    <FlexBox
      direction="column"
      wrap={false}
      style={{
        borderRadius: SPACING.space2,
        background: JoonUIColor.background.primaryNeutral,
        border: `1px solid ${JoonUIColor.border.default}`,
        overflow: "hidden",
        ...style,
      }}
    >
      {children}
    </FlexBox>
  )
}
